import { IYoutubeDataDTO } from '@/api/video/youtube/types/youtube-data.dto';
import { IContentLinkBlock } from '@/content-link/types/content-link';

export class ContentLinkHelper {
  static getPayload(contentLinkBlock: IContentLinkBlock, file: File): IContentLinkBlock {
    if (file) {
      const [thumbExtension]: string[] = file.name.split('.').reverse();
      return {
        ...contentLinkBlock,
        thumbUrl: undefined,
        thumbExtension,
      };
    }
    return contentLinkBlock;
  }

  static getSaveEditPayload(
    updatedBlock: IContentLinkBlock,
    currentBlock: IContentLinkBlock
  ): IContentLinkBlock {
    if (updatedBlock.thumbUrl === currentBlock.thumbUrl) {
      return {
        ...updatedBlock,
        id: currentBlock.id,
        thumbExtension: undefined,
        thumbUrl: undefined,
      };
    }
    return { ...updatedBlock, id: currentBlock.id };
  }

  static convertYoutubeDataToContentLink(youtubeData: IYoutubeDataDTO): Partial<IContentLinkBlock> {
    return {
      title: youtubeData.author_name,
      description: youtubeData.title,
      url: youtubeData.url,
      thumbUrl: youtubeData.thumbnail_url,
    };
  }
}
